﻿import { scroller } from '../../utilities/scroller';
import { toggleSlide } from '../../utilities/toggle-slide';

export const faqAccordion = () => {
    const selectors = {
        title: '.js-accordion-heading',
        content: '.js-accordion-content',
        faqOpen: 'page-accordion__title--open',
        accessibilityExpand: 'aria-expanded'
    };

    const config = {
        transitionTime: 300
    };

    var _toggleContentVisibility = function (el) {
        el.classList.toggle(selectors.faqOpen);

        var nextSibling = el.nextElementSibling;
        var isExpanded = (nextSibling.getAttribute(selectors.accessibilityExpand) === 'true');

        toggleSlide(nextSibling, config.transitionTime, null, !isExpanded);
        nextSibling.setAttribute(selectors.accessibilityExpand, (!isExpanded).toString());
    };

    const init = () => {
        document.querySelectorAll(selectors.title).forEach(item => {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                _toggleContentVisibility(this);
            })
        })

        var urlHash = window.location.hash;
        if (urlHash) {
            var element = document.querySelector('[data-faqitem="' + urlHash.substring(1) + '"]')
            if (element) {
                _toggleContentVisibility(element);
                scroller.scrollToElement(element);
            }
        }
    };

    return {
        init: init,
        selector: '.page-accordion'
    };
};
